"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateHexId24Symbols = exports.localhostSymbolicateRegex = exports.validateHexColor = exports.validateApiKey = void 0;
const validateApiKey = (key) => /^[a-z0-9]{16}$/.test(key);
exports.validateApiKey = validateApiKey;
const validateHexColor = (color) => /^#([0-9a-f]{3}){1,2}$/i.test(color);
exports.validateHexColor = validateHexColor;
const localhostSymbolicateRegex = (url) => /localhost:(.*)\/symbolicate$/.test(url);
exports.localhostSymbolicateRegex = localhostSymbolicateRegex;
const validateHexId24Symbols = (id) => /^(?:[0-9A-Fa-f]{24})$/.test(id);
exports.validateHexId24Symbols = validateHexId24Symbols;
